import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";

@Injectable({
    providedIn: 'root'
})
export class GroupService extends BaseRestService {

    readonly API_URL: string = environment.apiUri + '/customers/groups';

    getList(pageParams: any): Observable<any> {
        const options = {
            headers: this.headers,
            params: this.removeEmptyPropertyFromObject(pageParams)
        }
        return this.httpClient.get(this.API_URL, options);
    }

    getGroupId(): Observable<any> {
        const options = {
            headers: this.headers
        }
        return this.httpClient.get(this.API_URL + "/group-id", options);
    }

    getById(id: string): Observable<any> {
        return this.httpClient.get(this.API_URL + "/" + id,
            { headers: this.headers });
    }

    create(group): Observable<any> {
        return this.httpClient.post(this.API_URL, group,
            { headers: this.headers, responseType: "text" });
    }

    update(group, id: string): Observable<any> {
        return this.httpClient.put(this.API_URL + "/" + id, group,
            { headers: this.headers, responseType: "text" });
    }

    delete(id: string): Observable<any> {
        return this.httpClient.delete(this.API_URL + "/" + id,
            { headers: this.headers, responseType: "text" });
    }

    sendForApproval(data): Observable<any> {
        return this.httpClient.put(this.API_URL + "/send/for-approval", data,
            { headers: this.headers });
    }

    approve(data): Observable<any> {
        return this.httpClient.put(this.API_URL + "/approve", data,
            { headers: this.headers });
    }

    reject(data): Observable<any> {
        return this.httpClient.put(this.API_URL + "/reject", data,
            { headers: this.headers });
    }

    sendForRepairing(data): Observable<any> {
        return this.httpClient.put(this.API_URL + "/send/for-repairing", data,
            { headers: this.headers });
    }

}
